import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "dd-item-text" }
const _hoisted_3 = { class: "dd-item-text" }
const _hoisted_4 = { class: "dd-item-text" }
const _hoisted_5 = { class: "dd-item-text" }

import GlossaryModal from "@common/components/Glossary/GlossaryModal.vue";
import { TranslationSetType } from "@medapro-types/common/common-enum";
import { RootActions, RootState } from "@medapro-types/common/rootstate";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useActions, useState } from "vuex-composition-helpers";
import ConfirmationModal from "./ConfirmationModal.vue";
import Icon from "./Icon.vue";

//#region General

export default /*#__PURE__*/_defineComponent({
  __name: 'DeepLSplitButton',
  props: {
    allEntriesTranslateDisabled: { type: Boolean, default: false },
    allEntriesTranslateAvailable: { type: Boolean, default: true },
    allEntriesTranslateConfirmationRequired: { type: Boolean, default: true },
    emptyEntriesTranslateDisabled: { type: Boolean, default: false },
    emptyEntriesTranslateAvailable: { type: Boolean, default: true },
    emptyEntriesTranslateConfirmationRequired: { type: Boolean, default: true },
    selectedEntriesTranslateDisabled: { type: Boolean, default: false },
    selectedEntriesTranslateAvailable: { type: Boolean, default: false },
    selectedEntriesTranslateConfirmationRequired: { type: Boolean, default: true },
    overallTranslateActionAvailable: { type: Boolean, default: true },
    overallTranslateActionSetType: { default: TranslationSetType.All },
    glossaryAvailable: { type: Boolean, default: true },
    glossaryDisabled: { type: Boolean },
    glossaryModalName: { default: "deepl-button-glossary-modal" },
    disabled: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    textOnly: { type: Boolean },
    buttonClasses: { default: "mono" },
    buttonText: {},
    variant: { default: "secondary" }
  },
  emits: ["translate", "translateAll", "translateEmpty", "translateSelected"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();
//#endregion





const { user, userSettings } = useState<RootState>(["user", "userSettings"]);
const { saveUserSettings } = useActions<RootActions>(["saveUserSettings"]);

const confirmationModalRef = ref<typeof ConfirmationModal>();

const splitButtonClasses = computed(() => {
  return `${props.buttonClasses} ${props.iconOnly ? "btn-icon" : "btn-with-icon"}`;
});

const isDeepLVisible = computed(() => {
  return user.value.isDeeplAuthorized;
});

const onTranslate = async (setType: TranslationSetType) => {
  if (!(await confirmDeepLLegalWarning())) {
    return;
  }

  if (setType === TranslationSetType.Selected) {
    if (props.selectedEntriesTranslateConfirmationRequired && !confirm($t("translation.AskTranslateSelectedValues"))) {
      return;
    } else {
      emits("translateSelected");
    }
  } else if (setType === TranslationSetType.All) {
    if (props.allEntriesTranslateConfirmationRequired && !confirm($t("translation.askTranslateAllvalues"))) {
      return;
    } else {
      emits("translateAll");
    }
  } else if (setType === TranslationSetType.OnlyEmpty) {
    if (props.emptyEntriesTranslateConfirmationRequired && !confirm($t("translation.askTranslateEmptyValues"))) {
      return;
    } else {
      emits("translateEmpty");
    }
  }

  emits("translate", setType);
};

async function confirmDeepLLegalWarning() {
  if (userSettings.value.DeepLLegalInformationAccepted === "1") return true;
  try {
    const confirmation = await confirmationModalRef.value?.getConfirmation($t("LegalInformation"), $t("Activity.Description.DeepLLegalInformationText"));
    await saveUserSettings({ DeepLLegalInformationAccepted: confirmation == true ? "1" : "0" });
    return true;
  } catch (error) {
    return false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isDeepLVisible.value)
      ? (_openBlock(), _createBlock(_component_b_dropdown, {
          key: 0,
          split: "",
          "split-class": splitButtonClasses.value,
          "toggle-class": splitButtonClasses.value,
          class: _normalizeClass([{ 'disabled-split-button': props.disabled }, "split-button"]),
          variant: props.variant,
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (onTranslate(_unref(TranslationSetType).All)), ["prevent"])),
          disabled: props.disabled
        }, {
          "button-content": _withCtx(() => [
            (!props.textOnly)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 0,
                  icon: "DeepL-black"
                }))
              : _createCommentVNode("", true),
            (!props.iconOnly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.buttonText ?? _unref($t)("translation.deepLTranslation")), 1))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (props.allEntriesTranslateAvailable)
              ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                  key: 0,
                  "link-class": "icon-item",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onTranslate(_unref(TranslationSetType).All)), ["prevent"])),
                  disabled: props.allEntriesTranslateDisabled
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref($t)("translation.translateAllValues")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (props.emptyEntriesTranslateAvailable)
              ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                  key: 1,
                  "link-class": "icon-item",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onTranslate(_unref(TranslationSetType).OnlyEmpty)), ["prevent"])),
                  disabled: props.emptyEntriesTranslateDisabled
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref($t)("translation.translateOnlyEmptyValues")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (props.selectedEntriesTranslateAvailable)
              ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                  key: 2,
                  "link-class": "icon-item",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onTranslate(_unref(TranslationSetType).Selected)), ["prevent"])),
                  disabled: props.selectedEntriesTranslateDisabled
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref($t)("translation.TranslateOnlySelectedValues")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (props.glossaryAvailable)
              ? _withDirectives((_openBlock(), _createBlock(_component_b_dropdown_item, {
                  key: 3,
                  class: "glossary-item-with-divider",
                  disabled: props.glossaryDisabled
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref($t)("translation.editGlossary")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])), [
                  [_directive_b_modal, props.glossaryModalName]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["split-class", "toggle-class", "class", "variant", "disabled"]))
      : _createCommentVNode("", true),
    _createVNode(GlossaryModal, {
      "modal-name": props.glossaryModalName
    }, null, 8, ["modal-name"]),
    _createVNode(ConfirmationModal, { ref: "confirmModal" }, null, 512)
  ], 64))
}
}

})